document.addEventListener("DOMContentLoaded", function () {
    const videoElements = document.querySelectorAll(
      ".ugc-video-container .ugc-video-element"
    );
    const modal = document.getElementById("videoModal");
    const modalContent = document.querySelector(".video-modal-content");
    const modalClose = modalContent.querySelector(".video-modal-close");
    const muteButton = modalContent.querySelector(".video-modal-mute-button");
    const muteIcon = modalContent.querySelector(".video-modal-mute-button-icon");
    const unmuteIcon = modalContent.querySelector(
      ".video-modal-unmute-button-icon"
    );
    const videoList = modalContent.querySelector(".video-modal-list");
  
    // Navigation buttons
    const prevButton = document.getElementById("prevVideo");
    const nextButton = document.getElementById("nextVideo");
  
    // Debug logging
  
    let playTime = 0;
  
    let modalVideos = Array.from(
      modalContent.querySelectorAll(".modal-video-item")
    );
    let activeIndex = 0;
  
    // Check if device is mobile
    function isMobile() {
      return window.innerWidth <= 767;
    }
  
    function setMuteState(video, muted) {
      video.muted = muted;
      muteIcon.style.display = muted ? "none" : "flex";
      unmuteIcon.style.display = muted ? "flex" : "none";
    }
  
    function updateNavigationButtons() {
      if (prevButton && nextButton && !isMobile()) {
        prevButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === modalVideos.length - 1;
      }
    }
  
    function navigateToVideo(index) {
      if (index >= 0 && index < modalVideos.length) {
        activeIndex = index;
  
        if (isMobile()) {
          // Mobile: scroll to video
          modalVideos[activeIndex].scrollIntoView({
            behavior: "instant",
            block: "start",
          });
        } else {
          // Desktop: show only active video
          modalVideos.forEach((video, i) => {
            if (i === activeIndex) {
              video.classList.add("active");
            } else {
              video.classList.remove("active");
            }
          });
        }
  
        playActiveVideo();
        updateNavigationButtons();
      }
    }
  
    function playActiveVideo() {
      modalVideos.forEach((v, i) => {
        v.pause();
        v.currentTime = 0;
        if (i === activeIndex) {
          v.muted = false;
          v.play();
          setMuteState(v, false);
        } else {
          v.muted = true;
        }
      });
    }
    
    videoElements.forEach((video, index) => {
      video.addEventListener("click", () => {
        modal.style.display = "block";
        document.body.style.overflow = "hidden"; // 🔒
        activeIndex = index;
  
        if (isMobile()) {
          // Mobile: scroll to video
          modalVideos[activeIndex].scrollIntoView({
            behavior: "instant",
            block: "start",
          });
        } else {
          // Desktop: show only clicked video
          modalVideos.forEach((modalVideo, i) => {
            if (i === activeIndex) {
              modalVideo.classList.add("active");
            } else {
              modalVideo.classList.remove("active");
            }
          });
        }
  
        playActiveVideo();
        updateNavigationButtons();
      });
    });
  
    // Navigation button event listeners (desktop only)
    if (prevButton) {
      prevButton.addEventListener("click", () => {
        if (!isMobile()) {
          navigateToVideo(activeIndex - 1);
        }
      });
    }
  
    if (nextButton) {
      nextButton.addEventListener("click", () => {
        if (!isMobile()) {
          navigateToVideo(activeIndex + 1);
        }
      });
    }
  
    modalClose.addEventListener("click", () => {
      const activeVideo = modalVideos[activeIndex];
      const duration = activeVideo.duration || 0;
  
      let completionRate = 0;
  
      if (duration > 0) {
        completionRate = Math.min(100, (playTime / duration) * 100);
      }
  
    //   window?.trackMixpanelEvent("Closed FAQ Reel", {
    //     "page-url": window.location.pathname,
    //     source_domain: "foxtale-shopify",
    //     "completion-rate": completionRate.toFixed(1) + "%",
    //     "video-index": activeIndex,
    //   });
  
      modal.style.display = "none";
      document.body.style.overflow = ""; // 🔓
      modalVideos.forEach((v) => {
        v.pause();
        v.currentTime = 0;
      });
      playTime = 0;
    });
  
    muteButton.addEventListener("click", () => {
      const activeVideo = modalVideos[activeIndex];
      setMuteState(activeVideo, !activeVideo.muted);
    });
  
    modalVideos.forEach((video) => {
      video.addEventListener("click", () => {
        setMuteState(video, !video.muted);
      });
    });
  
    // Observer: detects active video & plays it (mobile only)
    const observer = new IntersectionObserver(
      (entries) => {
        if (isMobile()) {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
  
            const index = modalVideos.indexOf(entry.target);
  
            // window?.trackMixpanelEvent("Viewed FAQ Reel", {
            //   "page-url": window.location.pathname,
            //   source_domain: "foxtale-shopify",
            //   "faq-question": entry.target.dataset.faqQuestion,
            // });
  
            // if (activeIndex !== index) {
            // //   window?.trackMixpanelEvent("Scrolled FAQ Reels", {
            // //     "page-url": window.location.pathname,
            // //     source_domain: "foxtale-shopify",
            // //   });
            // }
            activeIndex = index;
            playActiveVideo();
          });
        }
      },
      { threshold: 0.7 }
    );
  
    modalVideos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      // Track play time
      video.addEventListener("timeupdate", () => {
        if (modalVideos.indexOf(video) === activeIndex) {
          playTime = video.currentTime;
        }
      });
      if (isMobile()) {
        observer.observe(video);
      }
    });
  
    // Initialize first video as active (desktop only)
    if (modalVideos.length > 0 && !isMobile()) {
      modalVideos[0].classList.add("active");
    }
  
    // vh fix for iOS
    function setVh() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh * 100}px`);
    }
  
    window.addEventListener("load", setVh);
    window.addEventListener("resize", setVh);
    window.addEventListener("orientationchange", setVh);
  
    // Keyboard navigation for desktop
    document.addEventListener("keydown", (e) => {
      if (modal.style.display === "block" && !isMobile()) {
        if (e.key === "ArrowLeft") {
          navigateToVideo(activeIndex - 1);
        } else if (e.key === "ArrowRight") {
          navigateToVideo(activeIndex + 1);
        } else if (e.key === "Escape") {
          modalClose.click();
        }
      }
    });
  
    // initial mute icon state
    setMuteState(modalVideos[activeIndex], false);
    updateNavigationButtons();
  });
  